import { render, staticRenderFns } from "./whatsapp-users-table.vue?vue&type=template&id=2d97c00e"
import script from "./whatsapp-users-table.vue?vue&type=script&lang=js"
export * from "./whatsapp-users-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports